import { render, staticRenderFns } from "./SendPromotion.vue?vue&type=template&id=ef4ab180&scoped=true"
import script from "./SendPromotion.vue?vue&type=script&lang=js"
export * from "./SendPromotion.vue?vue&type=script&lang=js"
import style0 from "./SendPromotion.vue?vue&type=style&index=0&id=ef4ab180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4ab180",
  null
  
)

export default component.exports